import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
// sidebar nav config
import navigation from './_nav'
import { images } from 'assets/icons'

const TheSidebar = props => {
  const dispatch = useDispatch()
  const show = useSelector(state => state.sidebarShow)

  const allowedNav = navigation.filter(item => {
    let allowedPermision = false
    if (props.user.role !== 'admin') {
      item.allowed.forEach(req =>
        props.user.permissions[req] === true
          ? (allowedPermision = true)
          : (allowedPermision = false)
      )
    }

    if (allowedPermision) {
      return item
    }
    return item.allowed.includes(props.user.role)
  })

  return (
    <CSidebar
      show={show}
      unfoldable
      onShowChange={val => dispatch({ type: 'set', sidebarShow: val })}
    >
      <CSidebarBrand className='d-md-down-none' to='/'>
        {/* <CIcon
          className='c-sidebar-brand-full'
          name='logo-negative'
          height={35}
        /> */}
        <img
          className='navbar-brand-full'
          src={images.LOGO}
          height='80'
          alt='Logo'
        />
        <CIcon
          className='c-sidebar-brand-minimized'
          name='sygnet'
          height={35}
        />
      </CSidebarBrand>
      <CSidebarNav>
        <CCreateElement
          items={allowedNav}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle
          }}
        />
      </CSidebarNav>
      <CSidebarMinimizer className='c-d-md-down-none' />
    </CSidebar>
  )
}

export default React.memo(TheSidebar)
